<template>
  <div>
    <Modal
      :mask-closable="false"
      :styles="{ top: ' 30%' }"
      :title="modalInfo.keyname"
      v-model="modal"
      width="390"
      @on-visible-change="onVisibleChange"
    >
      <!-- <span slot="close" style="color: #FF8C00;line-height:34px;">取消</span> -->
      <Icon custom="icon-pg-close"></Icon>
      <div>
        <Alert :type="errMsg.defaultMsg.type" v-if="errMsg.defaultMsg.isShow" show-icon>{{
          errMsg.defaultMsg.msg
        }}</Alert>
        <Alert :type="errMsg.custom.type" v-show="errMsg.custom.isShow" show-icon>{{
          errMsg.custom.msg
        }}</Alert>
        <Form ref="formCustom" :model="requestObj.changePassword.data" :rules="ruleCustom">
          <FormItem prop="passwordOld">
            <Input
              type="password"
              v-model.trim="requestObj.changePassword.data.passwordOld"
              placeholder="请输入旧密码"
              clearable
              style="width: 100%"
            ></Input>
          </FormItem>
          <FormItem prop="passwordNew">
            <Input
              type="password"
              v-model.trim="requestObj.changePassword.data.passwordNew"
              placeholder="请输入新密码"
              clearable
              style="width: 100%"
            ></Input>
          </FormItem>
          <FormItem prop="passwordCheck">
            <Input
              type="password"
              v-model.trim="requestObj.changePassword.data.passwordCheck"
              placeholder="请确认新密码"
              clearable
              style="width: 100%"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button
          type="primary"
          shape="circle"
          style="width: 160px"
          long
          :loading="loading"
          @click.enter="changePassword('formCustom')"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import { aesEncrypt } from 'pangu-components-plus'
export default {
  name: 'password',
  components: {},
  props: {
    modalInfo: {
      type: Object,
      default: {},
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    let that = this
    const validatePasswordOld = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入旧密码'))
      } else {
        callback()
      }
    }
    // else if (!/^^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*_-]+$)(?![a-zA-z\d]+$)(?![a-zA-z!@#$%^&*_-]+$)(?![\d!@#$%^&*_-]+$)[a-zA-Z\d!@#$%^&*_-]+$/g.test(value)) {
    //     callback(new Error('密码必须是8-20位大小写字母、数字、特殊字符！'));
    // }
    const validatePasswordNew = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (that.requestObj.changePassword.data.passwordCheck != '') {
        if (value != that.requestObj.changePassword.data.passwordCheck) {
          callback(new Error('两次密码输入不一致，请重新输入！'))
        } else {
          callback()
        }
      } else if (that.requestObj.changePassword.data.passwordOld != '') {
        if (value == that.requestObj.changePassword.data.passwordOld) {
          callback(new Error('新密码不能与旧密码相同，请重新输入！'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    // else if (!/^^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*_-]+$)(?![a-zA-z\d]+$)(?![a-zA-z!@#$%^&*_-]+$)(?![\d!@#$%^&*_-]+$)[a-zA-Z\d!@#$%^&*_-]+$/g.test(value)) {
    //         callback(new Error('密码必须是8-20位大小写字母、数字、特殊字符！'));
    //     }
    const validatePasswordCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认新密码'))
      } else if (value != that.requestObj.changePassword.data.passwordNew) {
        callback(new Error('两次密码输入不一致，请重新输入！'))
      } else if (that.requestObj.changePassword.data.passwordOld != '') {
        if (value == that.requestObj.changePassword.data.passwordOld) {
          callback(new Error('新密码不能与旧密码相同，请重新输入！'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      loading: false,
      modal: true,
      errMsg: {
        defaultMsg: {
          type: 'warning',
          isShow: false,
          msg: '一旦提交后再次修改请联系信息管理员。',
        },
        custom: {
          type: 'error',
          isShow: false,
          msg: '',
        },
      },
      curErrMsg: {},
      ruleCustom: {
        passwordOld: [{ validator: validatePasswordOld, trigger: 'blur' }],
        passwordNew: [{ validator: validatePasswordNew, trigger: 'blur' }],
        passwordCheck: [{ validator: validatePasswordCheck, trigger: 'blur' }],
      },
      requestObj: {
        // 设置手机号码
        // 表现为：页面上的输入框，点击确定按钮
        changePassword: {
          url: 'rest/main/security/changePassword',
          data: {
            passwordOld: '', //电话号码
            passwordNew: '', //验证码
            passwordCheck: '', //验证码
          },
        },
      },
    }
  },
  created() {
    this.modal = this.show
  },
  methods: {
    onVisibleChange(flag) {
      this.modal = flag
      this.$emit('visible-change', flag)
    },
    closeCustomAlert() {
      this.errMsg.custom.isShow = false
    },
    changePassword(name) {
      let that = this
      if (this.loading) return
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          //密码进行aes加密
          const param = {
            ...that.requestObj.changePassword.data,
            passwordOld: `{aes}${aesEncrypt(
              that.requestObj.changePassword.data.passwordOld,
              that.GLOBAL.secretKey
            )}`,
            passwordNew: `{aes}${aesEncrypt(
              that.requestObj.changePassword.data.passwordNew,
              that.GLOBAL.secretKey
            )}`,
            passwordCheck: `{aes}${aesEncrypt(
              that.requestObj.changePassword.data.passwordCheck,
              that.GLOBAL.secretKey
            )}`,
          }
          that.$axios
            .post(that.requestObj.changePassword.url, param)
            .then((res) => {
              that.loading = false
              console.log(res)
              if (res.data.code != 200) {
                that.errMsg.custom.isShow = true
                that.errMsg.custom.msg = res.data.msg
                that.closeMessage(3000)
                return
              }
              that.modal = false
              that.renderFunc(res.data.data)
              that.$emit('change-success')
            })
            .catch((res) => {
              that.loading = false
              that.$cfn.ajax1.catch1(res, that)
            })
        }
      })
    },
    renderFunc(msg) {
      let that = this
      this.$Message.success({
        closable: true,
        content: msg + '。即将重新登录...',
      })
      setTimeout(() => {
        this.$root.logout()
      }, 3000)
    },
    closeMessage(ms) {
      setTimeout(() => {
        this.errMsg.custom.isShow = false
      }, ms)
    },
  },
}
</script>
<style></style>
